'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _layout = require('../../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LandlordIcon = function (_React$Component) {
    _inherits(LandlordIcon, _React$Component);

    function LandlordIcon() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, LandlordIcon);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LandlordIcon.__proto__ || Object.getPrototypeOf(LandlordIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (size, color) {
            return _react2.default.createElement(
                'svg',
                { id: 'landlord-insurance', xmlns: 'http://www.w3.org/2000/svg', width: size, height: size, viewBox: '0 0 24 24' },
                _react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: size, height: size, fill: 'transparent' }),
                _react2.default.createElement(
                    'g',
                    { id: 'Group_63', transform: 'translate(-96.01 -692)' },
                    _react2.default.createElement(
                        'g',
                        { id: 'Bold_63' },
                        _react2.default.createElement('path', { fill: color, id: 'Shape_200', d: 'M112.25,708.05a.5.5,0,0,0,.5-.5v-8.8A4.756,4.756,0,0,0,108,694a4.707,4.707,0,0,0-2.348.627.5.5,0,0,0-.052.833,5.987,5.987,0,0,1-1.293,10.324.5.5,0,0,0-.307.461v7.005a.5.5,0,0,1-.147.35l-1.323,1.327a.748.748,0,0,1-1.06,0l-1.324-1.323a.5.5,0,0,1-.146-.354v-1.086a.5.5,0,0,0-.147-.353l-.53-.531a.751.751,0,0,1,0-1.06l.53-.531a.5.5,0,0,0,.147-.353v-.172a.5.5,0,0,0-.147-.353l-.53-.531a.751.751,0,0,1,0-1.06l.53-.531a.5.5,0,0,0,.147-.353v-.091a.5.5,0,0,0-.308-.461A6,6,0,0,1,102,694.25a5.449,5.449,0,0,1,.664.043.5.5,0,0,0,.426-.155,6.737,6.737,0,0,1,11.66,4.612v5.907a.5.5,0,0,0,.18.384l4.89,4.075a.5.5,0,0,1-.32.884h-1a.5.5,0,0,0-.5.5v5a.5.5,0,0,1-.5.5h-8a.5.5,0,0,1-.5-.5v-5a.5.5,0,0,0-.5-.5h-1a.5.5,0,0,1-.321-.884l4.161-3.467a.25.25,0,0,1,.41.192v1.709A.5.5,0,0,0,112.25,708.05Zm-11.867-9.38a1.751,1.751,0,1,0,.38-1.907A1.75,1.75,0,0,0,100.383,698.67Z', fillRule: 'evenodd' })
                    )
                )
            );
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(LandlordIcon, [{
        key: 'render',
        value: function render() {
            return this.getIcon(this.props.size || 24, this.props.color);
        }
    }]);

    return LandlordIcon;
}(_react2.default.Component);

exports.default = LandlordIcon;